import { GiftCardDto } from "../../store/models/RegistrationDto";

export const GIFTCARDS_PARAM = "gc";

/**
 * Gift cards packed by the giftcard delivery page into a single base64url "gc" param,
 * holding JSON [{ "n": <number>, "p": <pin> }, ...]. Decoded for prefilling the form.
 */
export function getGiftCardsFromUrl(search: string): GiftCardDto[] {
  const raw = new URLSearchParams(search).get(GIFTCARDS_PARAM);
  if (!raw) {
    return [];
  }
  try {
    const json = atob(raw.replaceAll("-", "+").replaceAll("_", "/"));
    const parsed = JSON.parse(json) as Array<{ n?: string; p?: string }>;
    return parsed
      .filter((entry) => entry && typeof entry.n === "string" && entry.n.trim().length > 0)
      .map((entry) => ({ giftCardNumber: entry.n!.trim(), pinCode: entry.p }));
  } catch {
    return [];
  }
}
